import { useCallback, useRef, useState } from 'react';
import { shallowEqual, useSelector } from 'react-redux';

import MediaService from '../../services/MediaService';
import UnitNavigation from '../../components/Navigation/UnitNavigation';
import Surprise from '../../components/World/Surprise/Surprise';
import { GetUserVideo, getVideo } from '../../s3Func/s3Download';

const Module16Nav = () => {
  const { module16 } = useSelector((state) => state.module16, shallowEqual);
  const { login } = useSelector((state) => state.loginReducer, shallowEqual);

  /*****************
   *  BG Image Logic
   * ***************/

  const [displaySurprise, setDisplaySurprise] = useState(false);
  const [surpriseConfig, setSurpriseConfig] = useState(null);
  const bgImage = useRef();

  const checkScreenSize = () => {
    const desktopImage =
      '/Module16Images/Unit4_Mod1BG.png';
    const mobileImage =
      '/Module16Images/Unit4_Mod1BG_phone.png';

    bgImage.current =
      window.screen && window.screen.width < 1025 ? mobileImage : desktopImage;
  };

  const resizeListener = useCallback(() => {
    window.addEventListener(
      'resize',
      (event) => checkScreenSize(),
      true
    );
  }, []);

  resizeListener();
  checkScreenSize();

  const backgroundPath =
    bgImage.current && MediaService.getImage(bgImage.current, login);
  const worldBG = MediaService.getImage(
    '/Module16Images/Unit4_Mod1BG.png',
    login
  );

  /*****************
   *  Day Logic
   * ***************/

  const getDayConfig = useCallback((dayNumber) => {
    const filledImageUrl = `/Module6Images/Module6NavImages/Underwater_journeymap_Day${dayNumber}.png`;
    const outlinedImageUrl = `/Module6Images/Module6NavImages/Underwater_journeymap_Day${dayNumber}_1.png`;

    return {
      dayNumber,
      destiny: '/manners',
      filledImageUrl,
      outlinedImageUrl,
    };
  }, []);

  const daysArray = [...Array(8).keys()];
  const DAYS_CONFIG = daysArray.map((index) => getDayConfig(index + 1));

  const SURPRISE_VIDEO = {
    song: 'appfiles/manners/manners_instrumental.m4a',
    slides: [
      `influencers/${login.influencerid}/greet_affirmation.mp4`,
      `userfiles/${module16.StudentID}/manners_celebration_surprise_5.mp4`,
      `influencers/${login.influencerid1}/greet_affirmation.mp4`,
      `userfiles/${module16.StudentID}/manners_celebration_surprise_7.mp4`,
      `influencers/${login.influencerid2}/greet_affirmation.mp4`,
      'appfiles/manners/practice_ferris_wheel_greeting.mp4',
      `userfiles/${module16.StudentID}/manners_practice_greet_7.mp4`,
      'appfiles/manners/practice_ferris_wheel_ask.mp4',
      `userfiles/${module16.StudentID}/manners_practice_ask_7.mp4`,
      'appfiles/manners/practice_ferris_wheel_respond.mp4',
      `userfiles/${module16.StudentID}/manners_practice_close_7.mp4`,
      'appfiles/manners/practice_ferris_wheel_close.mp4',
      `userfiles/${module16.StudentID}/manners_celebration_surprise_8.mp4`,
      `influencers/${login.influencerid3}/greet_affirmation.mp4`,
      `userfiles/${module16.StudentID}/manners_celebration_surprise_9.mp4`,
      `influencers/${login.influencerid4}/greet_affirmation.mp4`
    ],
  };

  const handleSurpriseClick = async () => {
    let { slides, song, video } = SURPRISE_VIDEO;

    slides = await Promise.all(
      slides.map(async (url) => await GetUserVideo(url, login))
    );
    song = await getVideo(song, login);

    setSurpriseConfig({ video, slides, song });
    setDisplaySurprise(true);
  };

  /*****************************
   *  Component configuration
   * ***************************/

  return (
    <>
      {displaySurprise && (
        <Surprise
          background={worldBG}
          setDisplaySurprise={setDisplaySurprise}
          video={surpriseConfig.video}
          song={surpriseConfig.song}
          slides={surpriseConfig.slides}
          onSurpriseEnded={() => setDisplaySurprise(false)}
        />
      )}

      {backgroundPath && (
        <UnitNavigation
          moduleName='MODULE16'
          module={module16}
          days={DAYS_CONFIG}
          totalDays={8}
          unitDestiny='/unit4'
          nextDestiny='/unit4'
          backgroundPath={backgroundPath}
          onSurpriseClick={handleSurpriseClick}
          unit={4}
          animal={MediaService.getImage('/Images/Button_CrabHead.png', login)}
        />
      )}
    </>
  );
};
export default Module16Nav;
